export default "__VITE_ASSET__DfhLF87T__"